import { WifiOff } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useOnlineStatus } from '@/hooks/use-online-status';

/**
 * The offline notice itself. Fixed across the top of the window, where the "new version"
 * banner goes (decision 12 a); `inline` for showing it in place (the /dev/ui gallery).
 */
export function OfflineBanner({ inline = false, className }: { inline?: boolean; className?: string }) {
  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        'flex items-center justify-center gap-2 border-b border-warning-border bg-warning-soft px-3 py-2 text-sm font-medium text-warning-strong',
        inline ? 'rounded-md border' : 'fixed inset-x-0 top-0 z-[10001] shadow-sm',
        className
      )}
    >
      <WifiOff className="size-4 shrink-0" aria-hidden />
      <span className="min-w-0">You&apos;re offline. jflo will carry on when your connection is back.</span>
    </div>
  );
}

/**
 * Says so while the browser is offline, and goes by itself when it's back. Mounted once per app
 * (app.tsx, the portal's main.tsx); failed requests meanwhile say "You're offline" too
 * (describeApiError).
 */
export function OfflineNotice() {
  const online = useOnlineStatus();
  return online ? null : <OfflineBanner />;
}
